import { MoreHorizontal } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

import { cn } from "@/lib/utils";

interface CustomDropdownTypes {
  data: ActionButtonDataTypes[];
}

export const CustomDropdown = ({
  data,
}: CustomDropdownTypes): React.JSX.Element => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' className='flex justify-center'>
          <MoreHorizontal className='w-4 h-4' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className='min-w-[200px] p-[6px] rounded-sm'
        align='end'
      >
        {data
          ?.filter((item) => !item.hide)
          .map((item) => {
            const Icon = item?.icon;

            return item.isLink ? (
              <Link to={item.isLink} state={{ id: item?.id }} key={item.name}>
                <DropdownMenuItem
                  className={cn(
                    `flex items-center  !pr-5 font-medium gap-2`,
                    item.isTrash && "text-red-600 hover:!text-red-600",
                    item?.textClassName,
                  )}
                >
                  <Icon size={16} />
                  <span>{item.name}</span>
                </DropdownMenuItem>
              </Link>
            ) : (
              <React.Fragment key={item.name}>
                <DropdownMenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.onclick) {
                      item.onclick();
                    }
                  }}
                  className={cn(
                    `flex items-center  !pr-5 font-medium gap-2`,
                    item.isTrash && "text-red-600 hover:!text-red-600",
                    item?.textClassName,
                  )}
                >
                  <Icon size={16} />
                  <span>{item.name}</span>
                </DropdownMenuItem>
              </React.Fragment>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
